import { useQuery } from '@apollo/client'
import { RequireVerifiedInstagramDocument } from '../../generated/backendGraphql'
import { ReactNode, useEffect } from 'react'
import { PageLoading } from '@bounty/creators-design-system'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { useRouter } from 'solito/router'

export const LOCALSTORAGE_INSTAGRAM_REDIRECT_URL = 'instagramRedirectURL'

type RequireVerifiedInstagramProps = {
  redirectToOnAuthSuccess: string
  children: ReactNode
}

export const RequireVerifiedInstagram = ({
  redirectToOnAuthSuccess,
  children,
}: RequireVerifiedInstagramProps) => {
  const { data, loading } = useQuery(RequireVerifiedInstagramDocument, {
    fetchPolicy: 'network-only',
  })
  const navigate = useRouter()

  useEffect(() => {
    const checkInstagram = async () => {
      if (
        data &&
        (data.instagramProfile?.verified === false || !data.instagramProfile)
      ) {
        await AsyncStorage.setItem(
          LOCALSTORAGE_INSTAGRAM_REDIRECT_URL,
          redirectToOnAuthSuccess,
        )
        navigate.push('/verify-instagram')
      }
    }

    checkInstagram()
  }, [data, navigate, redirectToOnAuthSuccess])

  if (loading || !data) {
    return <PageLoading />
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
